import type { FieldStateMap } from '@/utils/field-state'

export const profileDataTabs = ['person', 'household', 'professional'] as const

export type ProfileDataTab = (typeof profileDataTabs)[number]

export type ProfileTab = ProfileDataTab | 'documents'

/**
 * Where a profile field is edited. The catalog says which fields are required;
 * this map says which tab shows them, so the badges can be counted client side.
 */
const tabPerField: Record<string, ProfileDataTab> = {
  first_name: 'person',
  last_name: 'person',
  gender: 'person',
  birth_date: 'person',
  nationality: 'person',
  in_germany_since: 'person',
  tax_id: 'person',
  marital_status: 'person',
  address: 'person',
  email: 'person',
  phone: 'person',
  profession: 'professional',
  planned_retirement_date: 'professional',
  has_marital_contract: 'household',
  child_birth_date: 'household',
}

export const profileTabForField = (field: string): ProfileDataTab => tabPerField[field.split('.')[0]] ?? 'person'

export const missingPerProfileTab = (fieldStates: FieldStateMap): Record<ProfileDataTab, number> => {
  const counts = Object.fromEntries(profileDataTabs.map((tab) => [tab, 0])) as Record<ProfileDataTab, number>

  Object.values(fieldStates)
    .filter((field) => field.state === 'missing')
    .forEach((field) => {
      counts[profileTabForField(field.key)] += 1
    })

  return counts
}
